import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';

const Pricing = () => {
  const { language } = useLanguage();

  const [showForm, setShowForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    business: '',
    message: '',
  });

  const handleClick = (plan) => {
    setSelectedPlan(plan);
    setShowForm(true);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const baseURL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://dinikdelavega.com';

const res = await fetch(`${baseURL}/api/contact`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ ...formData, plan: selectedPlan }),
});



      const data = await res.json();
      if (data.success) {
        alert(
          language === 'id'
            ? `Terima kasih! Permintaan Anda untuk paket ${selectedPlan} telah dikirim.`
            : `Thank you! Your request for the ${selectedPlan} plan was submitted.`
        );
        setShowForm(false);
        setFormData({ name: '', email: '', mobile: '', business: '', message: '' });
      } else {
        alert(language === 'id' ? 'Gagal mengirim. Silakan coba lagi.' : 'Submission failed. Please try again.');
      }
    } catch (err) {
      console.error(err);
      alert(language === 'id' ? 'Terjadi kesalahan saat mengirim formulir.' : 'An error occurred while submitting the form.');
    }
  };

  const plans = {
  en: ['Starter', 'Professional', 'Business Plus'],
  id: ['Paket Dasar', 'Paket Profesional', 'Paket Bisnis Plus'],
};

const prices = {
  en: ['AUD$199', 'AUD$349', 'AUD$499+'],
  id: ['Rp 1.990.000', 'Rp 3.490.000', 'Rp 4.990.000+'],
};

  const features = [
    ['1-page React site', 'Mobile friendly', 'Hosting setup'],
    ['Up to 5 pages', 'SEO-friendly', 'Custom design'],
    ['Full custom site', 'Contact forms', 'Support & Updates'],
  ];

  const translatedFeatures = [
    ['Situs React 1 halaman', 'Responsif di HP', 'Pengaturan hosting'],
    ['Hingga 5 halaman', 'SEO-friendly', 'Desain kustom'],
    ['Situs kustom penuh', 'Formulir kontak', 'Dukungan & pembaruan'],
  ];

  return (
    <section id="pricing" className="bg-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-10">
          {language === 'id' ? 'Harga Jelas & Transparan' : 'Simple & Transparent Pricing'}
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {plans[language].map((plan, idx) => (
            <div
              key={plan}
              className={`border p-6 rounded-lg text-center ${plan === 'Professional' ? 'bg-blue-50' : ''}`}
            >
              <h3 className="text-xl font-bold mb-2">{plan}</h3>
              <p className="text-2xl font-semibold mb-4">{prices[language][idx]}</p>
              <ul className="text-left mb-4">
                {(language === 'id' ? translatedFeatures : features)[idx].map((feature) => (
                  <li key={feature}>✔ {feature}</li>
                ))}
              </ul>
              <button
                onClick={() => handleClick(plan)}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                {language === 'id'
                  ? plan === 'Business Plus'
                    ? 'Hubungi Saya'
                    : 'Mulai Sekarang'
                  : plan === 'Business Plus'
                    ? 'Contact Me'
                    : 'Get Started'}
              </button>
            </div>
          ))}
        </div>
      </div>

      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-xl font-bold mb-4">
              {language === 'id' ? `Permintaan Paket ${selectedPlan}` : `Request for ${selectedPlan} Plan`}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="text"
                name="name"
                placeholder={language === 'id' ? 'Nama Lengkap' : 'Full Name'}
                required
                className="w-full p-2 border rounded"
                onChange={handleChange}
                value={formData.name}
              />
              <input
                type="email"
                name="email"
                placeholder={language === 'id' ? 'Alamat Email' : 'Email Address'}
                required
                className="w-full p-2 border rounded"
                onChange={handleChange}
                value={formData.email}
              />
              <input
                type="tel"
                name="mobile"
                placeholder={language === 'id' ? 'Nomor HP' : 'Mobile Number'}
                required
                className="w-full p-2 border rounded"
                onChange={handleChange}
                value={formData.mobile}
              />
              <input
                type="text"
                name="business"
                placeholder={language === 'id' ? 'Nama Bisnis' : 'Business Name'}
                className="w-full p-2 border rounded"
                onChange={handleChange}
                value={formData.business}
              />
              <textarea
                name="message"
                placeholder={
                  language === 'id'
                    ? 'Pesan / Permintaan (opsional)'
                    : 'Message / Requirements (optional)'
                }
                rows="3"
                className="w-full p-2 border rounded"
                onChange={handleChange}
                value={formData.message}
              ></textarea>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="text-gray-600"
                >
                  {language === 'id' ? 'Batal' : 'Cancel'}
                </button>
                <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
                  {language === 'id' ? 'Kirim' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default Pricing;
